import { helpers } from "../util/helpers.ts";
import i18n from "../util/i18n.ts";
import { formatPlayerNameFromLegacyName } from "../util/playerNames.ts";
import { TeamAbbrevText } from "./TeamAbbrevLink.tsx";
import { createMobileReturnUrl } from "../util/mobilePageContext.ts";

const getMobileScrollY = () => (typeof window !== "undefined" ? window.scrollY : undefined);

const createHistoryPlayerHref = (pid: number, season: number) =>
  createMobileReturnUrl(helpers.leagueUrl(["player", pid]), {
    activeTab: String(season),
    filterKey: "historySeason",
    filterValue: season,
    pageID: "history",
    scrollY: getMobileScrollY(),
  });

export const RetiredPlayers = ({
  retiredPlayers,
  season,
  userTid,
}: {
  retiredPlayers: {
    age: number;
    hof: boolean;
    name: string;
    pid: number;
    ratings: {
      pos: string;
    };
    stats: {
      abbrev: string;
      tid: number;
    };
  }[];
  season: number;
  userTid: number;
}) => {
  return (
    <>
      <h2>{i18n.t("history.retiredPlayers", { ns: "ui", defaultValue: "Retired Players" })}</h2>
      <p className="retired-players-list">
        {retiredPlayers.length === 0
          ? i18n.t("history.none", { ns: "ui", defaultValue: "None" })
          : null}
        {retiredPlayers.map((p) => (
          <span key={p.pid} className={p.stats.tid === userTid ? "table-info" : undefined}>
            <a data-retired-player-link-pid={p.pid} href={createHistoryPlayerHref(p.pid, season)}>
              {formatPlayerNameFromLegacyName(p.name)}
            </a>{" "}
            (
            {p.stats.tid >= 0 ? (
              <>
                <a href={helpers.leagueUrl(["roster", `${p.stats.abbrev}_${p.stats.tid}`, season])}>
                  <TeamAbbrevText tid={p.stats.tid} abbrev={p.stats.abbrev} />
                </a>
                ,{" "}
              </>
            ) : null}
            {i18n.t("history.age", { ns: "ui", defaultValue: "age" })}: {p.age}
            {p.hof ? (
              <>
                ; <b>{i18n.t("history.hof", { ns: "ui", defaultValue: "HoF" })}</b>
              </>
            ) : null}
            )<br />
          </span>
        ))}
      </p>
    </>
  );
};
